export default {
    login: {
        title: '欢迎登录',
        mobile: '请输入手机号',
        password: '请输入密码',
        oldpassword: '请输入旧密码',
        confirmPwd: '请输入确认密码',
        verificationCode: '请输入验证码',
        loginIn: '登 录',
        register: '注 册',
        reset: '重置密码',
        resetPwd: '重置密码',
        editPwd: '修改密码',
        newPwd: '请输入新密码'
    },
    Notification: {
        suc_title: '成功',
        suc_login_msg: '成功登录',
        suc_register_msg: '成功注册',
        suc_send_msg: '成功发送',
        suc_edit_msg: '成功修改',
        suc_reset_msg: '成功重置',
        codeAgain: '重新获取验证码',
        suc_submit: '成功提交',
        login_tip: '请先登录',
        tip: '提示',
        sure: '确定',
        next: '下一步',
        requiredFields: '请完善必填项',
        nodata: '暂无数据',
        read: '已读',
        unread: '未读',
        cancel: '取消',
        suc_confirm_msg: '成功确认'
    },
    tougao: {
        submit: '提交',
        correct_mobile: '请输入正确的手机号',
        correct_email: '请输入正确的邮箱',
        corrent_card: '请输入正确的证件号',
        basic_info: '基本信息',
        zuopin_info: '作品信息',
        cancel: '取消',
        sure: '确定',
        print: '打印',
        submit_tip: '确认提交后不可再修改, 是否继续',
        suc_confirm_msg: '成功确认',
        receipt: '投稿回执'
    },
    my: {
        name: '名称',
        category: '类别',
        ticket: '流水号',
        status: '状态',
        operate: '操作',
        edit: '修改',
        sure: '确认',
        view: '查看',
        receipt: '回执',
        logout: '退 出',
        activity: '报名列表',
        personal: '个人资料',
        message: '消息列表',
        personalInfo: '个人信息',
        myActivity: '我的报名',
        myMessage: '我的消息',
        personalCenter: '个人中心',
        filter: '筛选',
        keyPlhder: '请输入搜索关键字',
        statusPlhder: '请选择活动状态',
        num: '序号',
        activityName: '活动名称',
        desc: '描述',
        createTime: '创建时间',
        enable: '启用',
        disabled: '禁用',
        apply: '报名',
        zuopinCategory: '作品类别',
        zuopinName: '作品名称',
        submitTime: '投稿时间',
        submit: '提交',
        zuopinList: '作品列表',
        back: '返回',
        add: '新增',
        nodata: '暂无数据',
        msgDetail: '消息详情',
        personTip: '请谨慎保管个人信息',
        editPwdTip: '请谨慎保管密码',
        avatar: '头像',
        uploadAvatar: '上传头像',
        realName: '真实姓名',
        realNamePlac: '请输入真实姓名',
        mobile: '手机号码',
        sex: '性别',
        sexPlac: '请选择性别',
        editPersonal: '修改信息',
        oldPwd: '旧密码',
        newPwd: '新密码',
        confirmPwd: '确认密码',
        oldPwdTip: '请输入旧密码',
        newPwdTip: '请输入新密码',
        confirmPwdTip: '请输入确认密码'
    }
}
